interface AvatarProps {
  src?: string;
  label?: string;
  size?: number;
  /** "circle" (default) or a rounded square tile, as on the listing cards. */
  shape?: "circle" | "rounded";
}

function getColorFromString(str: string) {
  const colors = [
    "bg-blue-600",
    "bg-emerald-700",
    "bg-purple-600",
    "bg-pink-600",
    "bg-amber-700",
    "bg-cyan-700",
    "bg-rose-600",
    "bg-indigo-600",
  ];

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
}

export function Avatar({
  src,
  label,
  size = 36,
  shape = "circle",
}: AvatarProps) {
  const radius = shape === "rounded" ? "rounded-xl" : "rounded-full";
  const safeLabel =
    typeof label === "string" && label.trim().length > 0 ? label : "?";

  const initials = safeLabel
    .split(" ")
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const bgColor = getColorFromString(safeLabel);

  if (src) {
    return (
      <img loading="lazy" decoding="async"
        src={src}
        alt={safeLabel}
        width={size}
        height={size}
        className={`${radius} object-cover`}
      />
    );
  }

  return (
    <div
      className={`
      flex items-center justify-center
      ${radius}
      text-white font-semibold
      ${bgColor}
    `}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        lineHeight: `${size}px`,
        fontSize: size * 0.4,
      }}
      aria-label={safeLabel}
    >
      {initials}
    </div>
  );
}
